import React from 'react';
import CatalogPage from '../../components/CatalogPage/CatalogPage';
import { materialService } from '../../services/api';

const MaterialRegistration: React.FC = () => (
  <CatalogPage
    title="Materiais"
    subtitle="Cadastre e gerencie os materiais utilizados na conclusão das ordens de serviço."
    listTitle="Materiais cadastrados"
    listDescription="Estes materiais aparecerão no checklist de conclusão de OS no mobile. Itens excluídos são removidos da listagem, mas os já registrados em conclusões anteriores permanecem nos históricos."
    placeholder="Nome do material (ex: CABO PP 2X1.5)"
    service={materialService}
  />
);

export default MaterialRegistration;
